export const clearAuthData = () => {
  const itemsToRemove = [
    "accessToken",
    "tokenExpiration",
    "cachedAzureUsageData",
    "cachedPlanData",
    "cachedProjects",
    "projectsCacheTimestamp",
    "persist:root",
    "report"
  ];

  itemsToRemove.forEach(item => localStorage.removeItem(item));
};

/**
 * Limpa o cache de projetos do usuário específico para forçar refetch.
 * @param {string} email - E-mail do usuário logado.
 */
export const clearProjectCache = (email) => {
  const suffix = (email || "").trim().toLowerCase() || "anon";
  const CACHE_VERSION = "v2"; // Sincronizado com Dashboard.jsx

  const keys = [
    // Dashboard v2 (suffixed)
    `cachedPlanData_${CACHE_VERSION}_${suffix}`,
    `cachedAzureUsageData_${CACHE_VERSION}_${suffix}`,
    `cacheTimestamp_${CACHE_VERSION}_${suffix}`,
    `cachedProjectsData_${CACHE_VERSION}_${suffix}`,
    `projectsCacheTimestamp_${CACHE_VERSION}_${suffix}`,

    // Projects.jsx (suffixed)
    `cachedProjects_${suffix}`,
    `cachedPlanData_${suffix}`,
    `cachedAzureUsageData_${suffix}`,
    `projectsCacheTimestamp_${suffix}`,

    // Legacy / Generic keys
    "cachedProjects",
    "cachedPlanData",
    "cachedAzureUsageData",
    "projectsCacheTimestamp",
    "cachedProjectsData_v2",
    "cachedAzureUsageData_v2",
    "projectsCacheTimestamp_v2",
  ];

  keys.forEach(k => localStorage.removeItem(k));
  console.log(`[v4d:Cache] Cache limpo para suffix: ${suffix}`);
};
